import { Fragment } from 'react';
import { BlockWrapper, defineBlock, useEditor } from '@smartfire/js-block-engine';
import { ReactComponent as LinkedIn } from '../assets/images/linkedIn.svg';
import { ReactComponent as Logo } from '../assets/images/logo.svg';
import style from './block.module.scss';

const Footer = ({ menu, linkedInUrl }) => {
    const { isEditing } = useEditor();

    return (
        <BlockWrapper.Footer className={style.block}>
            <a href="/" className={style.logo}>
                <Logo />
            </a>
            <div className={style.content}>
                <div className={style.links}>
                    <p>SOCIATY</p>
                    {isEditing ? (
                        <p>les éléments du menu apparaîtront ici</p>
                    ) : (
                        Object.values(menu).map((el) => (
                            <Fragment key={el.url}>
                                <span> - </span>
                                <a href={el.url} className={style.menuItem}>
                                    {el.title}
                                </a>
                            </Fragment>
                        ))
                    )}
                </div>

                <a href={linkedInUrl} rel="noopener noreferrer" target="_blank" className={style.social}>
                    <LinkedIn />
                </a>
            </div>
        </BlockWrapper.Footer>
    );
};

export default defineBlock({
    Block: Footer,
    setup: {
        title: 'Footer',
    },
});
